var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bottomBannerData.module_picture != '')?_c('div',{staticClass:"indexBannerBar"},[_c('van-image',{attrs:{"src":_vm.bottomBannerData.module_picture}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }